import React from 'react';
import { Typography, withStyles } from '@material-ui/core';

const styles = theme => ({
  root: {
    fontSize: 18,
    lineHeight: '22px',
    textTransform: 'uppercase',
    marginBottom: 25,
    color: '#3A3A3A',
  },
});

const PageSubTitle = withStyles(styles)(({ classes, children }) => {
  return <Typography className={classes.root}>{children}</Typography>;
});

export default PageSubTitle;
